<template>
	<div>
		<p-section-content-grid v-show="isDataLoaded" class="custom-fade-in">
			<div class="full-section-height tse-left-content" slot="left">
				<three-sixty-evaluation-stepper
					:current-step="currentStep"
					:step-labels="stepLabels"
					class="tw-mb-4"
				/>
				<!-- content steps -->
				<choose-the-job v-if="currentStep === 1" class="custom-fade-in"></choose-the-job>

				<template v-for="(step, index) in dynamicSteps">
					<required-skills
						v-if="currentStep === index + 2"
						class="custom-fade-in"
						:key="index"
						:step-config="step"
					>
					</required-skills>
				</template>
				<evaluation-questions
					v-if="currentStep === dynamicSteps.length + 2"
					:last-step-config="lastStep"
					class="custom-fade-in"
					@prevStep="goPrev()"
					@saveClick="handleSave()"
				></evaluation-questions>
				<selected-answer
					v-if="currentStep === dynamicSteps.length + 3"
					class="custom-fade-in"
					@prevStep="goPrev()"
					@saveClick="handleSave()"
					@getAnswerId="getAnswerId">
				</selected-answer>
			</div>
			<template slot="right">
				<three-sixty-evaluation-name-description />
			</template>
		</p-section-content-grid>
		<three-sixty-evaluation-name-dialog
			ref="evaluationNameDialog"
			@onConfirmClick="handleConfirmSurveyName($event)"
		></three-sixty-evaluation-name-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import bus from '@/bus/app-bus';
import { map, path, pathOr, prop } from 'ramda';
import InformationCard from '../../shared/components/content/InformationCard';
import ThreeSixtyEvaluationStepper from '../components/three-sixty-evaluation-stepper';
import ChooseTheJob from '../components/first-step/choose-the-job';
import ChooseTheJobDescription from '../components/first-step/components/choose-the-job-description';
import PSectionContentGrid from '../../shared/components/ui/p-section-content-grid';
import RequiredSkills from '../components/second-step/required-skills';
import RequiredSkillsTutorialSection from '../components/second-step/components/required-skills-tutorial-section';
import EvaluationQuestions from '../components/third-step/evaluation-questions';
import selectedAnswer from '../components/fourth-step/selected-answer';
import ThreeSixtyEvaluationNameDialog from '../three-sixty-evaluation-name-dialog';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from '../store/store.constant';
import { getStepLabels, tseNamespace } from '../utils';
import ThreeSixtyEvaluationNameDescription from '../three-sixty-evaluation-description';
import { MAIN_LOADER_EVENT } from '../../shared/components/ui/p-main-loader.constants';

export default {
	name: 'page-new-three-sixty-evaluation',
	components: {
		ThreeSixtyEvaluationNameDescription,
		ThreeSixtyEvaluationNameDialog,
		EvaluationQuestions,
		selectedAnswer,
		RequiredSkillsTutorialSection,
		RequiredSkills,
		PSectionContentGrid,
		ChooseTheJobDescription,
		ChooseTheJob,
		ThreeSixtyEvaluationStepper,
		InformationCard,
	},
	async mounted() {
		await this.loadFlowData();
	},
	data() {
		return {
			isDataLoaded: false,
			answerId: null,
		};
	},
	computed: {
		...mapState(THREE_SIXTY_EVALUATION_NAMESPACE, {
			moduleConfiguration: pathOr([], ['moduleConfiguration']),
			currentStep: pathOr([], ['evaluationFlow', 'currentStep']),
		}),
		stepLabels() {
			return getStepLabels(map(prop('stepTitle'), this.dynamicSteps));
		},
		dynamicSteps() {
			return pathOr([], ['steps', 'dynamicSteps'], this.moduleConfiguration);
		},
		lastStep() {
			return pathOr([], ['steps', 'lastStep'], this.moduleConfiguration);
		},
	},
	methods: {
		path,
		goPrev() {
			this.currentStep = this.currentStep - 1;
		},
		goNext() {
			this.currentStep = this.currentStep + 1;
		},
		handleSave() {
			this.$refs.evaluationNameDialog.openDialog();
		},
		getAnswerId(id) {
			this.answerId = id;
		},
		async loadFlowData() {
			try {
				await this.$store.dispatch(tseNamespace('getToolConfiguration'));
				this.isDataLoaded = true;
			} catch (e) {
				console.error('An error occurred getting the data for new evaluation', e);
				this.showGenericError('Hubo un error recuperando la data para iniciar el flujo.');
			}
		},
		async handleConfirmSurveyName(surveyName) {
			bus.$emit(MAIN_LOADER_EVENT, { show: true, message: 'Procesando...' });
			try {
				await this.$store.dispatch(tseNamespace('createSurvey'), { surveyName, answerId: this.answerId });
				await this.$store.dispatch(tseNamespace('resetState'));
				bus.$emit(MAIN_LOADER_EVENT, { show: false });
				this.$refs.evaluationNameDialog.reset();
				// this.$router.push('/');
				this.goTo('list-polls-evaluation360');
				// do the redirection here
			} catch (e) {
				bus.$emit(MAIN_LOADER_EVENT, { show: false });
				this.showGenericError('Hubo un error en el proceso.');
				console.error('An error occurred creating the survey', e);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.tse-left-content {
	height: 100%;
	display: flex;
	flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/pages/page-new-three-sixty-evaluation.vue